import React from 'react';
import { Box, Stack } from '@mui/material';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { LenderRetailActivityDealerRowViewModel, LenderRetailActivityStateRowViewModel } from '../../../api/types';
import { GeographicBreakdownMap } from './GeographicBreakdownMap';
import { DealerActivityTable } from './DealerActivityTable';

interface Props {
  stateRows: LenderRetailActivityStateRowViewModel[];
  dealerRows: LenderRetailActivityDealerRowViewModel[];
  isStateLoading?: boolean;
  isDealerLoading?: boolean;
}

export const CreditApps = ({ stateRows, dealerRows, isStateLoading, isDealerLoading }: Props) => (
  <CardContainer title="Credit Apps">
    <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
      <GeographicBreakdownMap rows={stateRows} loading={isStateLoading} />
      <DealerActivityTable rows={dealerRows} loading={isDealerLoading} />
    </Box>
  </CardContainer>
);
